import { forwardRef } from 'react';

/**
 * A visual divider (spec §7.1). Decorative by default (`role="none"`, per the
 * WAI-ARIA APG guidance for separators that carry no semantic boundary); pass
 * `decorative={false}` when the separator marks a real content boundary a
 * screen reader should announce.
 *
 * @param {object} props
 * @param {'horizontal'|'vertical'} [props.orientation='horizontal']
 * @param {boolean} [props.decorative=true]
 * @param {string} [props.className]
 */
export const Separator = forwardRef(function Separator(
  { orientation = 'horizontal', decorative = true, className = '', ...rest },
  ref
) {
  return (
    <hr
      ref={ref}
      className={`etch-separator ${className}`.trim()}
      data-orientation={orientation === 'vertical' ? 'vertical' : undefined}
      role={decorative ? 'none' : 'separator'}
      aria-orientation={!decorative ? orientation : undefined}
      {...rest}
    />
  );
});

export default Separator;
